import { Link } from 'react-router-dom';
import { tracking } from '../../../../utils/tracking';
import { NewButton } from '../NewButton';
import styles from './VideoSection.module.css';

const url = "https://www.youtube.com/embed/9o0uXtzun58?mute=1";

export const VideoSection = () => {
   return (
      <div className={styles.container}>
         <section className={styles.aboutSection} >
            <div>
               <h2>What is the <span>Venture Summit</span>?</h2>
               {/* <div></div> */}
               <p>
                  The Emerging Tech Venture Summit is a two-day conference that will introduce and explore the latest Tech innovations and solutions. Set in the world’s biggest and most active technology hub, Silicon Valley is the base for some of the biggest global tech companies.
               </p>
               <p>
                  The Venture Summit is put together by youngStartup Ventures, which has a stellar track record for putting together incredible winning events that showcase 100s of startups and brings over 100 VCs together.
               </p>
               <p>
                  Come and join top innovators, tech leaders, and leading investors!
               </p>
            </div>
            <div style={{ paddingTop: "10%" }}>
               {/* <Link to='/events/etvs23/registration' onClick={() => tracking(273)}>
                  <NewButton name='TICKETS' color='white' bgColor='#CF1B5B' />
               </Link> */}
               <a href='https://youngstartup.com/upcoming' onClick={() => tracking(273)}>
                  <NewButton name='TICKETS' color='white' bgColor='#CF1B5B' />
               </a>
            </div>
         </section>

         <section className={styles.videoSection}>
            <div style={{
               position: "relative",
               paddingBottom: "56.25%",
               height: "100%",
               width: "100%",

               top: "50%",
               transform: "translateY(-50%)",
            }}>
               <iframe
                  style={{
                     position: "absolute",
                     top: "0",
                     left: "0",
                     width: "100%",
                     height: "100%",
                  }}
                  src={url}
                  title="YouTube video player" frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen
               />
            </div>
         </section>
      </div>
   );
}